import Article from '@mui/icons-material/Article'
import BorderAll from '@mui/icons-material/BorderAll'
import Email from '@mui/icons-material/Email'
import FormatAlignLeft from '@mui/icons-material/FormatAlignLeft'
import Image from '@mui/icons-material/Image'
import InsertDriveFile from '@mui/icons-material/InsertDriveFile'
import PictureAsPdf from '@mui/icons-material/PictureAsPdf'

export const getIcon = (filetype: File['type'] | null) => {
  if (!filetype) return <InsertDriveFile />

  switch (filetype) {
    case 'text/plain':
      return <FormatAlignLeft />
    case 'application/pdf':
      return <PictureAsPdf />
    case 'application/vnd.ms-outlook':
      return <Email />
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return <Article />
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return <BorderAll />
    case filetype.match(/^image/)?.input:
      return <Image />
    default:
      return <InsertDriveFile />
  }
}

export const getColorByFiletype = (filetype: File['type'] | null): CSSStyleDeclaration['color'] | undefined => {
  if (!filetype) return undefined

  switch (filetype) {
    case 'text/plain':
      return '#343434'
    case 'application/pdf':
      return '#e30b36'
    case 'application/vnd.ms-outlook':
      return '#0072C6'
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return '#2B579A'
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return '#1E7443'
    case filetype.match(/^image/)?.input:
      return '#dc5116'
    default:
      return undefined
  }
}
